/* jshint esversion: 6 */
/* jshint ignore:start */
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { getDistance } from "geolib";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import { LuStar, LuMapPin, LuChevronRight } from "react-icons/lu";

const ShopList = () => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [list, setList] = useState([]);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const navigate = useNavigate();
  const Categoreyid = sessionStorage.getItem("Catid");

  const fetchHomeData = useCallback(
    (lat, long, pageNum) => {
        
      if (!Categoreyid || Categoreyid == null) {
        navigate("/");
        return;
      }

      const Userid = secureLocalStorage.getItem("Userid") || "0";
      if (Userid) {
        axios
          .post(`${ApiBaseUrl}/customer/store_list`, {
            uid: Userid,
            category_id: Categoreyid,
            lat: lat,
            lon: long,
            page: pageNum,
          })
          .then((res) => {
            console.log("Shop List", res);
            const { ResponseCode, store_list } = res.data;
            if (ResponseCode === 200) {
              if (store_list.length === 0) NoMoreDataRef.current = false;
              setLoading(false);
              setList((prev) =>
                pageNum === 1 ? store_list : [...prev, ...store_list],
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    [ApiBaseUrl, Categoreyid],
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    navigator.geolocation.getCurrentPosition((position) => {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      setLatitude(lat);
      setLongitude(long);
      fetchHomeData(lat, long, 1);
    });
  }, [fetchHomeData]);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current) return;
    fetchHomeData(latitude, longitude, page);
  }, [page, latitude, longitude, fetchHomeData]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage((prevPage) => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const HandleDistance = (lat1, long1, lat2, long2) => {
    if (!lat1 || !long1 || !lat2 || !long2) return "0.00";
    const distance = getDistance(
      { latitude: lat1, longitude: long1 },
      { latitude: lat2, longitude: long2 },
    );

    const Tofixed = (distance / 1000).toFixed(2);

    return Tofixed;
  };

  const HandleNavigate = (Docid) => {
    navigate("/store-home");
    sessionStorage.setItem(
      "Docdetails",
      JSON.stringify({ Categoreyid, Docid }),
    );
  };

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  return (
    <div className="w-full width-container pb-[50px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
      ) : (
        <div className="flex flex-col">
          {/* Header Breadcrumbs Section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoIosArrowBack className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Home")}</span>
            </Link>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Link
                to="/shop"
                className="hover:text-indigo-600 font-medium transition-colors"
              >
                {t("Shop")}
              </Link>
              <IoIosArrowForward className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("Shop List")}
              </span>
            </div>
          </div>

          <div className="mt-4">
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
                {t("Verified Pharmacy Stores")}
              </h2>
              <p className="text-sm text-slate-500 mt-1">
                {t("Select a store to view items and order")}
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {list.length >= 1 ? (
                list.map((item, index) => {
                  return (
                    <div
                      onClick={() => HandleNavigate(item.id)}
                      key={index}
                      className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 flex flex-col relative isolate"
                    >
                      <div className="relative h-48 md:h-52 overflow-hidden bg-slate-100 rounded-t-3xl isolate">
                        <ImageLoad
                          src={ImgBaseUrl + item.image}
                          CustomeStyle={
                            "w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 transform-gpu"
                          }
                          alt={item.name}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-300"></div>

                        <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-md text-slate-800 text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-sm">
                          <LuMapPin className="w-3.5 h-3.5 text-indigo-600" />
                          <span>
                            {HandleDistance(
                              latitude,
                              longitude,
                              item.latitude,
                              item.longitude,
                            )}{" "}
                            km
                          </span>
                        </div>
                      </div>

                      <div className="p-5 flex-1 flex flex-col justify-between">
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-1.5">
                            <h3 className="font-bold text-slate-800 text-[16px] group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full">
                              {item.name}
                            </h3>
                            <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full shrink-0 border border-amber-100">
                              <LuStar className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
                              <span className="text-xs font-bold leading-none">
                                {item.rating_avg}
                              </span>
                            </div>
                          </div>

                          <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">
                            {item.address}
                          </p>
                        </div>

                        <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-indigo-600 font-semibold text-sm">
                          <span>{t("Visit Store")}</span>
                          <span className="w-7 h-7 bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-indigo-600 group-hover:text-white">
                            <LuChevronRight className="w-4 h-4" />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-full bg-slate-50 rounded-3xl p-10 flex flex-col items-center justify-center text-center border border-dashed border-slate-200/80">
                  <div className="w-16 h-16 bg-slate-200/50 rounded-full flex items-center justify-center text-slate-400 mb-4">
                    <LuMapPin className="w-8 h-8" />
                  </div>
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("No Stores Available")}
                  </h3>
                  <p className="text-slate-500 text-sm max-w-xs mt-1">
                    {t(
                      "We couldn't find any certified pharmacies near your location.",
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopList;
/* jshint ignore:end */
